<template lang="pug">
div.custom-text-field
  label.custom-label
  input.custom-input(
    :type="inputType"
    :value="displayValue"
    :placeholder="placeholder"
    :style="{height: height + 'px'}"
    :readonly="readonly"
    @input="onInput"
  )
  div.custom-details
    span {{ details }}
</template>

<script>
export default {
  name: 'CastomTextField',
  props: {
    value: null,
    placeholder: null,
    details: null,
    height: { 
      type: Number, 
      default: 36 
    },
    readonly: { 
      type: Boolean, 
      default: false 
    },
    type: { 
      type: String, 
      default: "text" 
    }
  },

  computed: {
    displayValue() {
      if (this.type !== "money") return this.value;

      let num = Number(String(this.value).replace(/\D/g, ""));
      if (!num) return "";
      return num.toLocaleString("ru-RU").replace(/\s/g, ",");
    },

    inputType() {
      return this.type === "money" ? "text" : this.type;
    }
  },

  methods: {
    onInput(e) {
      let val = e.target.value;

      if (this.type !== "money") {
        this.$emit("input", val);
        return;
      }
      let numeric = val.replace(/\D/g, "");
      let number = Number(numeric);
      this.$emit("input", number);
    }
  }
}
</script>

<style scoped>
.custom-text-field {
  position: relative;
  display: flex;
  flex-direction: column;
}
.custom-label {
  font-size: 14px;
  color: #666;
  margin-bottom: 4px;
  transition: color 0.2s;
}
.custom-input {
  padding: 10px 12px;
  border: 2px solid #ccc;
  border-radius: 12px;
  outline: none;
  font-size: 16px;
  transition: border-color 0.2s, box-shadow 0.2s;
  background: white;
}
.custom-input:focus {
  border-color: #1976d2;
  box-shadow: 0 0 4px rgba(25, 118, 210, 0.3);
}
.custom-details {
  font-size: 13px;
  color: #888;
  margin-top: 4px;
}
</style>
